import { t } from "@/i18n-js/instance";
import { ListingCard } from "../ListingCard";
import { LabelWithDetail } from "./LabelWithDetail";

interface TagListCardProps {
  resources: Array<{ name: string; id: string; is_public?: boolean }>;
}

const getVisibilityLabel = (isPublic?: boolean) => {
  if (isPublic === undefined) return null;

  const statusKey = isPublic ? "public" : "private";
  const translationKey = `help_widget.copilot.chat_card.tag_visibility.${statusKey}`;
  const translated = t(translationKey);

  return translated === translationKey ? statusKey : translated;
};

export const TagListCard = ({ resources }: TagListCardProps) => (
  <ListingCard
    title={t("help_widget.copilot.chat_card.member_tags")}
    resources={resources}
    emptyStateText={t("help_widget.copilot.chat_card.no_member_tags_found")}
    renderItem={tag => (
      <LabelWithDetail
        label={tag.name}
        detail={getVisibilityLabel(tag.is_public)}
      />
    )}
    getItemKey={tag => tag.id}
  />
);
